export default __webpack_public_path__ + "static/PC_bg_01-ccecf1c71030e6f4219894dc8b30545e.png";